<script>
import resources from './resources'

export default {
  name: 'patient-gadget',
  mixins: [resources]
}
</script>

<template lang="pug">
  //- .col-xs-12.col-sm-9.col-md-12.content-wrapper(@scroll='handleScroll')
  //-     page-search-bar
  //-       .col-xs-12.content(@scroll='handleScroll')
  //-         .container-fluid
  //-           .row
  //-             Tags
  //-             //- search
  //-             //- identification
  //-             //- dates
  //-             statistics
  //-             upcoming
  //-             family

  page(title="Bem-vindo(a) ao Medibook!",icon="", v-if="!topSearchBar")
      .col-xs-12.content
        .container-fluid
          .row
            Tags
            //- search
            //- identification
            //- dates
            statistics
            upcoming
            family
  </template>



// WEBPACK FOOTER //
// src/app/patient/dashboard/gadget/index.vue